import { Badge, Layout, Menu } from 'antd';
import classNames from 'classnames';

import { HotelMigrationLogo } from '../Icons/HotelMigrationLogo';

import './SideMenuHotelMigration.scss';

const { Sider } = Layout;

type SideMenuProps = {
  setSelectedKey: (key: number) => void;
  selectedKey: number;
  items: { key: number; label: string }[];
  disabled?: boolean;
};

export const SideMenuHotelMigration = ({
  setSelectedKey,
  selectedKey,
  items,
  disabled = false,
}: SideMenuProps) => {
  return (
    <Sider width={220} className="hotel-migration-sider">
      <div className="title">
        <HotelMigrationLogo />
      </div>
      <Menu
        className="hotel-migration-sider__menu"
        mode="inline"
        selectedKeys={[selectedKey.toString()]}
        defaultSelectedKeys={['0']}
        theme="dark"
        items={items.map((item) => {
          const isActive = selectedKey === item.key;
          const isNextKey = selectedKey + 1 === item.key;
          const isPastKey = selectedKey > item.key;

          return {
            key: item.key.toString(),
            disabled: (!isNextKey && !isPastKey) || disabled,
            onClick: () => setSelectedKey(item.key),
            label: (
              <div
                className={classNames('hotel-migration-sider__menu__item', {
                  active: isActive,
                })}
              >
                <Badge color={isActive ? '#FF2E63' : 'grey'} />
                {item.label}
              </div>
            ),
          };
        })}
      />
    </Sider>
  );
};
